<template>
  <v-row :class="[className, 'ma-0', 'root', 'previous-next-navigation']">
    <v-btn
      icon
      large
      class="nav-btn"
      :color="navIndex !== 0 ? 'primary' : 'default'"
      :disabled="navIndex <= 0"
      @click="$emit('on-prev')"
    >
      <v-icon class="nav-icon">
        mdi-chevron-left
      </v-icon>
    </v-btn>
    <v-btn
      icon
      large
      :color="navIndex < navLast ? 'primary' : 'default'"
      class="nav-btn"
      :disabled="navIndex >= navLast"
      @click="$emit('on-next')"
    >
      <v-icon class="nav-icon">
        mdi-chevron-right
      </v-icon>
    </v-btn>
  </v-row>
</template>

<script>
export default {
  props: {
    navIndex: {
      type: Number,
      default: 0,
    },
    navLast: {
      type: Number,
      default: 0,
    },
    className: String,
  },
};
</script>

<style lang="scss" scoped>
.root {
  display: 'flex';
  column-gap: 0.5rem;
}
.nav-icon {
  font-size: 22px !important;
}
.prev-nav {
  margin-top: -6px !important;
}
.nav-btn {
  border: 1px solid var(--v-primary-base);
  background-color: white;
  height: 28px;
  width: 28px;
  &:disabled {
    background-color: unset;
    border-color: var(--v-default-base);
  }
}
</style>
